/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React from 'react';
import {Link, withRouter} from "react-router-dom";
import intl from 'react-intl-universal';

import QueryNavbar from "../components/AppNavbar";
import {isUserSignedIn, UserContext, isUserProfileLoaded, getLinkForSignIn} from "../UserContext";

import Loading from "../components/Loading";

import { renderMetaTagsForFingHelp } from "../helpers/MetaTagsHelper";
import { formatSmartAbsoluteDate } from '../helpers/DateHelper';

// const fake_tickets = [
// {
// ticketId: "8B5E7BA29EAFD768",
// state: "OPEN",
// userId: "god@fing.io",
// creationDate: "2019-11-15T12:45:23.000+0000",
// closeDate: null,
// sharedUserIds: null,
// sharePIN: null,
// communityDiscussionId: null
// },
// {
// ticketId: "E7C11EF57499FB2C",
// state: "OPEN",
// userId: "god@fing.io",
// creationDate: "2019-11-15T09:53:16.000+0000",
// closeDate: null,
// sharedUserIds: null,
// sharePIN: null,
// communityDiscussionId: null
// },
// {
// ticketId: "20D1E7F87BD04B5C",
// state: "OPEN",
// userId: "god@fing.io",
// creationDate: "2019-11-10T17:21:19.000+0000",
// closeDate: null,
// sharedUserIds: null,
// sharePIN: null,
// communityDiscussionId: "1828"
// },
// {
// ticketId: "E20DEFE0D67AE7E4",
// state: "CLOSED",
// userId: "god@fing.io",
// creationDate: "2019-11-10T10:24:38.000+0000",
// closeDate: "2019-11-12T10:24:38.000+0000",
// sharedUserIds: null,
// sharePIN: null,
// communityDiscussionId: null
// },
// {
// ticketId: "AB7527FA3DF8D4F0",
// state: "OPEN",
// userId: "god@fing.io",
// creationDate: "2019-11-08T16:30:39.000+0000",
// closeDate: null,
// sharedUserIds: null,
// sharePIN: null,
// communityDiscussionId: null
// },
// {
// ticketId: "FA750CBB3DC0E818",
// state: "NEW",
// userId: "god@fing.io",
// creationDate: "2019-11-15T10:09:30.000+0000",
// closeDate: null,
// sharedUserIds: null,
// sharePIN: null,
// communityDiscussionId: null
// }
// ];

class ListHelpTicketView extends React.Component {

    static contextType = UserContext;

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isFound: false,
            isUnauthorized: false,
            tickets: null
        };
    }

    validateRestResponse(response) {
        if (response.status !== 200) {
            if (response.status === 401) this.setState({ isUnauthorized: true });
            throw Error(response.statusText);
        }
        return response;
    }

    catchRestError(error) {
        console.error(error);
        this.setState({ isLoading: false, isFound: false });
    }

    componentDidMount() {
        const url = '/rest/internet/helpme/helptickets';
        // return this.setState({ tickets: fake_tickets, isLoading: false, isFound: true, isUnauthorized: false });
        fetch(url)
            .then(response => this.validateRestResponse(response))
            .then(response => {
                console.log(response);
                return response.json();
            })
            .then(data => {
                this.setState({ tickets: data.tickets, isLoading: false, isFound: true, isUnauthorized: false });
            })
            .catch(e => this.catchRestError(e))
            ;

    }

    // --------------------------------------------------------------------------------
    // ANCILLARY RENDER
    // --------------------------------------------------------------------------------

    renderTicketCard(ticket) {
        let badgeStyle=ticket.state === 'CLOSED' ? 'badge-success' : ticket.state === 'NEW' ? 'badge-danger' : 'badge-warning';
        return (
            <div className="card card-frame border-1 mb-3">
                <Link to={'/helpme/view/' + ticket.ticketId}>
                    <div className="container p-4">
                        <div className="row ml-3">
                            <div className="small text-muted">
                                {formatSmartAbsoluteDate(ticket.creationDate)}
                                {ticket.state === 'CLOSED' && "  •  Closed on " + formatSmartAbsoluteDate(ticket.closeDate)}
                            </div>
                        </div>
                        <div className="row ml-3">
                            <h5 className="h5 mb-0 text-dark">Query <a className="link-underline" href={'https://query.fing.com/' + ticket.ticketId}>{ticket.ticketId}</a>
                                <span className={"badge ml-2 my-auto "+badgeStyle}>{ticket.state}</span></h5>
                        </div>
                    </div>
                </Link>
            </div>
        );
    }

    renderTicketCards(tickets) {
        if (!tickets || tickets.length < 1) {
            return (
                <div className="card card-frame border-1 mb-3">
                    <div className="container p-4">
                        <div className="row ml-3">
                            <h5 className="h3 mb-3 text-dark">
                                {intl.get('query_no_tickets_title')}
                            </h5>
                        </div>
                        <div className="row ml-3">
                            <div className="text-secondary">
                                {intl.get('query_no_tickts_description')}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return tickets.slice(0).map(t => this.renderTicketCard(t));
    }

    // --------------------------------------------------------------------------------
    // MAIN RENDER
    // --------------------------------------------------------------------------------

    render() {
        const { isLoading, tickets } = this.state;

        if (isLoading || !isUserProfileLoaded(this.context)) {
            return <Loading />
        }

        const isSignedIn = isUserSignedIn(this.context);
        return (
            <div>
                {renderMetaTagsForFingHelp("My Queries on Fing", "Queries on Fing: help troubleshoot connectivity problems.")}
                <QueryNavbar />
                <main id="content" role="main">
                    <div className="container space-2">
                        <div className="w-lg-80 mx-lg-auto">
                        {isSignedIn ? (
                            this.renderTicketCards(tickets) 
                        ) : (
                            <div className="card shadow-sm p-7">
                            <h1 className="font-weight-semi-bold text-primary">Access to queries</h1>
                            <h1 className="h6 text-secondary">You need to login to your Fing account in order to access and manage your queries.</h1>
                            <span>
                                <a className="btn btn-primary btn-pill btn-wide transition-3d-hover mt-5"
                                   href={getLinkForSignIn(this.context, window.location.href)}>Login to access</a>
                            </span>
                        </div>
                        )}
                        </div>
                    </div>
                </main>
            </div>
        );
    }

}

export default withRouter(ListHelpTicketView);